export const PROVIDER_ID_REQUIRED = "Provider ID is required";
export const NO_VARIANT_PRESENT = "No variant present in Activate event";
export const NO_EXPERIMENT_ID = "No experiment ID is present";
export const NO_EVENT_KEY = "No 'key' present in Conversion event";
export const NO_EVENT_UUID = "No 'uuid' present in event";
export const NO_VISITOR_ID = "No 'visitor_id' present in event";
